import { defineComponent as _defineComponent } from 'vue'
import Button from '@/components/buttons/Button.vue';
import Checkbox from '@/components/inputs/Checkbox.vue';
import RadioButtons from '@/components/inputs/RadioButtons.vue';
import Search from '@/components/search/Search.vue';
import { ActionItem } from '@/lib/actionItems';
import { Icon } from '@/lib/enum/Icon';
import { computed, ref, useSlots } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileHeaderSearch',
  props: {
    placeholder: null,
    query: { default: '' },
    sortOptions: { default: () => [] },
    selectedSortOption: { default: null },
    filterOptions: { default: () => [] },
    selectedFilters: { default: () => ({}) },
    appendButtonWidth: { default: 45 },
    disabled: { type: Boolean, default: false }
  },
  emits: ["queryChange", "sortChange", "filterChange"],
  setup(__props: any) {

const props = __props as { placeholder: string, query: string, sortOptions: ActionItem[], selectedSortOption: ActionItem, filterOptions: ActionItem[], selectedFilters: Record<ActionItem['id'], boolean>, appendButtonWidth: number, disabled: boolean }





const slots = useSlots();

const shouldShowAppendButton = computed<boolean>(
  () =>
    !!(
      slots['append-button'] ||
      props.sortOptions.length + props.filterOptions.length
    ),
);

const inputFocused = ref(false);

const menuVisible = ref(false);

const showMenu = () => {
  if (!inputFocused.value) menuVisible.value = !menuVisible.value;
};

const inputRef = ref(null);

return { __sfc: true,props, slots, shouldShowAppendButton, inputFocused, menuVisible, showMenu, inputRef, Button, Checkbox, RadioButtons, Search, Icon }
}

})